import { Checkbox } from 'antd';
import AntCheckbox from './styles/checkbox.style';

const checkbox = AntCheckbox(Checkbox);
const CheckboxGroup = Checkbox.Group;

export default checkbox;
export { CheckboxGroup };



// WEBPACK FOOTER //
// ./src/components/uielements/checkbox.js